function openPopup(e) {
    const target = e.target.closest('.js-open-popup')
    const popupId = target.dataset.popup
    if (!popupId) return

    const popup = document.querySelector('#' + popupId)

    closeOpenedPopups()

    popup.classList.remove('hidden')
    document.body.classList.add('popup-active')

    document.dispatchEvent(
        new CustomEvent("popup:opened", { detail: e.target.closest('.js-open-popup')})
    )
}

function popupClickHandler(e) {
    if (e.target.closest('.js-open-popup')) {
        openPopup(e)
    } else if (e.target.closest('.js-close-popup') || !e.target.closest('.popup')) {
        closePopup(e)
    }
}

function closePopup(e) {
    const popup = e.target.closest('.popup-wrapper')
    if (!popup) return

    popup.classList.add('hidden')
    document.body.classList.remove('popup-active')

    document.dispatchEvent(
        new CustomEvent("popup:closed", { detail: popup})
    )
}

function closeOpenedPopups() {
    const activePopup = document.querySelector('.popup-wrapper:not(.hidden)')
    if (activePopup) {
        activePopup.classList.add('hidden')
    }
}

document.addEventListener('click', popupClickHandler)
